import * as React from "react"

export default function CarIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.065 5.857c.057.008.111.03.159.063l3.399 2.397 1.797.29a3.541 3.541 0 012.552 1.812c.06.112.092.239.092.366v.674c0 .365-.145.715-.403.973l-.039.039a1.375 1.375 0 01-.972.402h-.623a1.955 1.955 0 01-3.664 0H6.117a1.955 1.955 0 01-3.665-.004 1.372 1.372 0 01-.913-.398l-.2-.2a1.376 1.376 0 01-.402-.972v-.175c0-.364.144-.715.402-.973l.042-.041a.625.625 0 00.183-.442V8.87c0-.346.13-.68.366-.933l1.52-1.644c.26-.281.626-.441 1.009-.441h6.549l.057.005zm-6.78 5.13a1.206 1.206 0 101.153 1.554c-.001-.014-.003-.028-.003-.043 0-.068.019-.13.05-.185a1.206 1.206 0 00-1.2-1.326zm10.91 0a1.206 1.206 0 100 2.411 1.206 1.206 0 000-2.412zM4.46 6.601a.625.625 0 00-.458.2l-1.52 1.643a.626.626 0 00-.167.425v.798c0 .365-.145.714-.403.972l-.042.042a.626.626 0 00-.182.442v.175c0 .166.065.325.182.442l.2.2a.62.62 0 00.264.153 1.955 1.955 0 013.905.03h7.004a1.954 1.954 0 013.906 0h.502a.625.625 0 00.442-.183l.039-.04a.627.627 0 00.183-.442v-.674A2.79 2.79 0 0016.3 9.347l-1.852-.299H4.512a.626.626 0 01-.574-.876l.688-1.57h-.167zm.243 1.696H8.02V6.602H5.444l-.742 1.696zm4.068 0h4.526l-2.407-1.696h-2.12v1.696z"
        fill={props.fill}
      />
    </svg>)
}
